import eight from "../assets/svg/projects/eight.svg";
import seven from "../assets/svg/projects/seven.svg";
import six from "../assets/svg/projects/six.svg";
import twelve from "../assets/svg/projects/twelve.svg";
import thirteen from "../assets/svg/projects/thirteen.svg";
import four from "../assets/svg/projects/four.svg";

export const projectsData = [
  {
    id: 1,
    projectName: "Autoencoder Applications",
    projectDesc:
      "Implemented a Convolutional & Denoising Autoencoder, achieving a test accuracy of 90.4%, demonstrating strong performance in denoising images.Utilized this for image colorization achieving a Mean Colorization Accuracy (MCA) of 92%.",
    tags: [""],
    code: "",
    demo: "https://github.com/GauravYS/Autoencoder-Applications",
    image: twelve,
  },
  {
    id: 2,
    projectName: "Job Portal App",
    projectDesc:
      "Developed a job portal app with MVC architecture, dynamic theming, and interactive dashboard.Facilitated user job tracking and allowed admins to efficiently manage job lifecycle.",
    tags: ["MongoDB", "Express.js", "React.js", "Node.js", "Material UI"],
    code: "https://github.com/GauravYS/Job-Portal-Application",
    demo: "",
    image: thirteen,
  },
  {
    id: 3,
    projectName: "Ridecare",
    projectDesc:
      "This project tackles the issue of rider safety in ride hailing services.Various pretrained models such as BERT,RoBERTA,XLM,XLNet were used.It also incolved using Perspective API & Twilio.",
    tags: [],
    code: "https://github.com/GauravYS/Project-RideCare-",
    demo: "",
    image: four,
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
